import React from "react";
import PropTypes from "prop-types";
import { useMediaQuery } from "react-responsive";
import StrategicAnalysisMobile from "./StrategicAnalysisMobile";
import StrategicAnalysisDesktop from "./StrategicAnalysisDesktop";

function StrategicAnalysis({ config }) {
  const isMobile = useMediaQuery({ query: "(max-width: 980px)" });

  return isMobile ? (
    <StrategicAnalysisMobile config={config} />
  ) : (
    <StrategicAnalysisDesktop config={config} />
  );
}

StrategicAnalysis.defaultProps = {
  app: null,
  config: {},
};

StrategicAnalysis.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default StrategicAnalysis;
